var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Chevron, Err, Errors, Field, FieldWrapper, Helper, Input } from './form-elements/shared.js';
import { moz } from './helpers/target-vendor.js';
import Copy from './copy.js';
const StyledFieldWrapper = styled(FieldWrapper).withConfig({ displayName: "brc-StyledFieldWrapper", componentId: "brc-18x2m7c" }) `
  & > ${Copy} {
    margin-left: 18px;
  }
`;
const SelectField = styled(Input).attrs(() => ({ as: 'select' })).withConfig({ displayName: "brc-SelectField", componentId: "brc-1jtnxjp" }) `
  width: 100%;
  appearance: none;
  color: inherit;
  cursor: pointer;
  border-radius: 20px;
  font-size: 16px;
  padding: 8px 16px;
  outline: 0;
  background: ${({ isInvalid, theme }) => (isInvalid ? theme.sebastianRed100 : theme.transparentWhite)};
  border: 2px solid ${({ isInvalid, theme }) => (isInvalid ? theme.sebastianRed200 : theme.bubbleBlue500)};

  ${({ disabled, theme }) => disabled &&
    `
    color: ${theme.scuttleGray500};
    border-color: ${theme.scuttleGray200};
    background: ${theme.scuttleGray100};
    cursor: not-allowed
    `};

  &:focus {
    background: ${({ theme }) => theme.bubbleBlue100};
  }

  ${moz `
    // Selects in firefox have extra, unstylable, 3px of whitespace around the text.
    padding-left: 10px;

    // Focusable elements in firefox have a focus ring around sub-elements.
    &:-moz-focusring {
      color: transparent;
      text-shadow:0 0 0 ${({ theme }) => theme.neutral500};
    }
    &:-moz-focusring * {
      color: ${({ theme }) => theme.neutral500};
      text-shadow:none;
    }
  `}
`;
const defaultValue = { label: '...', value: '' };
const SelectPill = (_a) => {
    var { className, disabled, errors = [], hasSpaceForErrors, helperText, isInvalid, label, onChange, options = [], required, value = defaultValue } = _a, props = __rest(_a, ["className", "disabled", "errors", "hasSpaceForErrors", "helperText", "isInvalid", "label", "onChange", "options", "required", "value"]);
    return (_jsxs(StyledFieldWrapper, Object.assign({ className: className }, { children: [label && (_jsx(Copy, Object.assign({ light: true, size: "sm" }, { children: label }))), _jsxs(Field, Object.assign({ isInvalid: isInvalid, required: required }, { children: [_jsx(SelectField, Object.assign({ disabled: disabled, isInvalid: isInvalid, onChange: onChange, required: required, value: value }, props, { children: [defaultValue, ...options].map((option) => {
                            const { label = option, value = option } = option;
                            return (_jsx("option", Object.assign({ value: value, hidden: !value }, { children: label }), `${label}:${value}`));
                        }) })), _jsx(Chevron, { name: "actions/carrot-down", disabled: disabled, isInvalid: isInvalid })] })), helperText && _jsx(Helper, { hasSpaceForHelper: hasSpaceForErrors, helperText: helperText }), _jsx(Errors, Object.assign({ hasSpaceForErrors: hasSpaceForErrors }, { children: !!errors.length && errors.map((err, i) => _jsx(Err, { children: err }, `err-${i}`)) }))] })));
};
export default styled(SelectPill).withConfig({ componentId: "brc-1kb7h97" }) ``;
//# sourceMappingURL=select-pill.js.map